<!--
 * @Descripttion: 市场数据报表
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-07-08 10:02:04
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-07-08 17:59:35
-->
<template>
    <div class="marketDataReport">
        <div class="title-wrap">
            <div class="tag"></div>
            <div class="title">市场数据报表</div>
        </div>
        <div class="case-wrap select-wrap">
            <div class="top-select" v-if="userInfo.kf_level == 1">
                <div class="select">
                    <el-select class="sele" clearable  @change="selectChangeMarket" v-model="userId" placeholder="请选择专员筛选">
                        <el-option
                            v-for="item in marketOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div class="title">
                <div class="title-wrap">
                    <div class="tag"></div>
                    <div class="title">数据汇总</div>
                </div>
            </div>
            <div class="content-wrap" v-loading="loading1">
                <div class="item">
                    <span>{{basicData.count}}</span>目标品牌数
                </div>
                <div class="item">
                    <span>{{basicData.cooperate_count}}</span>合作品牌数
                </div>
                <div class="item">
                    <span>{{basicData.shop_count}}</span>门店合作数
                </div>
                <div class="item">
                    <span>{{basicData.follow_count}}</span>跟进数
                </div>
            </div>
        </div>
        <div class="case-wrap echart-wrap">
            <div class="title-wrap">
                <div class="tag"></div>
                <div class="title">服务数据</div>
            </div>
            <div class="echart" v-loading="loading2">
                <div id="cooperationMtGrades" style="width: 35%;height: 350px;"></div>
                <div class="line-wrap">
                    <div class="screen-wrap">
                        <commonSelect
                            @changeDate="changeDate"
                            @clickTagDate="clickTagDate"
                        ></commonSelect>
                    </div>
                    <div id="followMtGrades" style="width: 100%;height: 350px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import pageMixin from '@/internal/pageMixin'
import common from "@/utils/common.js"
import commonSelect from "@/components/commonSelect.vue"
import {cooperationMtPieEcharts} from "@/echarts/pieEchartData";
import {followMtLineEcharts} from "@/echarts/lineEchartData";
export default {
    components: {
        commonSelect
    },
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'marketDataReport',
            userInfo: {},
            userId: '',
            marketOptions: [],
            loading1: false,
            loading2: false,
            basicData: {},
            dateType: '',
            startDate: '',
            endDate: ''
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if(this.userInfo.kf_level != 1){
            this.userId = this.userInfo.id;
        }
        this.getDataReport();
        this.getUserConditions();
        this.getPieDataReport();
        this.getLineDataReport();
    },
    methods: {
        selectChangeMarket(){
            this.getDataReport();
            this.getPieDataReport();
            this.getLineDataReport();
        },
        // 日期选择
        changeDate(startDate,endDate){
            this.startDate = startDate.slice(0,11)+' 00:00:01';
            this.endDate = endDate.slice(0,11)+' 23:59:59';
            this.getLineDataReport();
        },
        clickTagDate(item){
            this.dateType = item.label;
            if(item.label != 'date'){
                this.startDate = '';
                this.endDate = '';
                this.getLineDataReport();
            }
        },
        // 获取跟进数据
        getLineDataReport(){
            let params = {
                user_id: this.userId,
                date_type: this.dateType,
                start_date: this.startDate,
                end_date: this.endDate
            }
            common.connect("/customerservicev1/data_report/marketDataReportLineChart",params,(res)=>{
                followMtLineEcharts('followMtGrades',res.data);
            });
        },
        // 获取饼图数据
        getPieDataReport(){
            let params = {
                user_id: this.userId
            }
            this.loading2 = true;
            common.connect("/customerservicev1/data_report/marketDataReportPieChart",params,(res)=>{
                cooperationMtPieEcharts('cooperationMtGrades',res.data.enterprise_brand);
                this.loading2 = false;
            });
        },
        // 获取基本数据
        getDataReport(){
            let params = {
                user_id: this.userId
            }
            this.loading1 = true;
            common.connect("/customerservicev1/data_report/marketDataReport",params,(res)=>{
                this.basicData = res.data;
                this.loading1 = false;
            });
        },
        // 获取用户数据
        getUserConditions(){
            common.connect("/customerservicev1/admin/marketUserConditions",{},(res)=>{
                let resultSecond =  res.data.map(v =>{
                return{
                    value: v.user_id,
                    label: v.nickname
                }
                })
                this.marketOptions = resultSecond;
            });
        },
    },
}
</script>

<style scoped lang='scss'>
.marketDataReport{
    background: rgb(240, 242, 245);
    padding: 10px 25px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    .title-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 5px 0;
        .tag{
            width: 4px;
            height: 20px;
            background: #409EFF;
            border-radius: 10px;
        }
        .title{
            font-size: 18px;
            font-weight: bold;
            padding-left: 10px;
        }
    }
    .case-wrap{
        background: #fff;
        padding: 20px;
        margin: 20px 0;
        border-radius: 6px;
        .title-wrap{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin: 5px 0;
            .tag{
                width: 3px;
                height: 15px;
                background: #409EFF;
                border-radius: 10px;
            }
            .title{
                font-size: 16px;
                font-weight: bold;
                padding-left: 10px;
            }
        }
    }
    .select-wrap{
        .top-select{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .select{
                .sele{
                    margin-right: 20px;
                }
            }
            .iconfont{
                font-size: 26px;
                cursor: pointer;
            }
        }
        
        .title{
            margin: 10px 0;
        }
    }
    .content-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item{
            border: 1px solid #ddd;
            border-radius: 6px;
            width: 20%;
            display: flex;
            justify-content: center;
            align-items: baseline;
            height: 120px;
            line-height: 120px;
            span{
                font-size: 26px;
                font-weight: bold;
                color: #000000;
                margin-right: 10px;
            }
        }
    }
    .echart-wrap{
        .echart{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .line-wrap{
                width: 65%;
                display: flex;
                flex-direction: column;
            }
        }
        
    }
}
</style>
